import { useState, useEffect } from 'react';

import urls from 'src/sections/repository/urls';
import authRequest from 'src/utils/fetch';

export type AnnotatedRefData = {
  isLoading: boolean;
  isUnreachable: boolean;
  branchNames: string[];
  tagNames: string[];
};

const fetchData = async (repoSlug: string, hash: string) => {
  const url = urls.api.internal.commitAnnotated(repoSlug, hash);
  const resp = await fetch(authRequest(url));
  return resp.json();
};

export const useFetchCommitAnnotated = (
  repoSlug: string,
  hash: string
): AnnotatedRefData => {
  const [annotatedRefs, setAnnotatedRefs] = useState<AnnotatedRefData>({
    isLoading: true,
    isUnreachable: false,
    branchNames: [],
    tagNames: [],
  });

  useEffect(() => {
    if (!repoSlug || !hash) {
      return;
    }
    fetchData(repoSlug, hash).then(data => {
      setAnnotatedRefs({
        isLoading: false,
        isUnreachable: Array.isArray(data) && !data.length,
        branchNames:
          // API response is in the form of a nested list where the 2nd element
          // of the first nested element contains the branch names we want
          Array.isArray(data) &&
          data.length &&
          Array.isArray(data[0]) &&
          data[0].length >= 2
            ? data[0][1]
            : [],
        tagNames:
          // API response is in the form of a nested list where the 3rd element
          // of the first nested element contains the tag names we want
          Array.isArray(data) &&
          data.length &&
          Array.isArray(data[0]) &&
          data[0].length >= 2
            ? data[0][2]
            : [],
      });
    });
  }, [setAnnotatedRefs, repoSlug, hash]);

  return annotatedRefs;
};
